<template>
  <div />
</template>
<style scoped>
body {
  background: #fff;
}
.wrap {
  width: 1200px !important;
  margin: 16px auto 0;
  padding: 0;
}
.wrap img {
  width: 100%;
}
</style>
<script>
import { RedirectOld } from '@/networks/api'
import { mapState } from 'vuex'
export default {
  name: 'RedirectOld',
  computed: {
    ...mapState({
      xAreaID: state => state.xAreaID
    })
  },
  mounted() {
    const { courseType, grade, subject } = this.$route.params
    const data = {
      courseType: parseInt(courseType),
      gradeId: parseInt(grade),
      subjectAlias: subject,
      provinceId: this.xAreaID
    }
    RedirectOld.getRedirect(data)
      .then(response => {
        if (response.data && response.data.stat === 1) {
          if (Number(response.data.data.gradeId) === 24) {
            response.data.data.gradeId = 25
          }
          const { courseType:_courseType, gradeId, subjectAlias } = response.data.data
          if (!gradeId) {
            window.location.replace(window.location.origin)
          }
          if (_courseType && gradeId && subjectAlias) {
            window.location.replace(
              `${window.location.origin}/course-center/s${_courseType}/s${gradeId}/s${subjectAlias}`
            )
            return
          }
        }
        window.location.replace(window.location.origin)
      })
      .catch(response => {
        window.location.replace(window.location.origin)
      })
  }
}
</script>



// WEBPACK FOOTER //
// ./src/views/RedirectOldCenter.vue